module.exports = __webpack_public_path__ + "f528cb37af46b60064c7528660e2bf9b.jpg";